/*
 * @Author: Json Chen
 * @Date: 2021-07-28 16:12:27
 * @LastEditTime: 2021-07-28 16:13:36
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/localisation.ts
 */
import { get, post } from 'src/tools/server';

export const getLocalisation = (salesChannelUuid) => {
  return get<any>(
    `/portal/setting/salesChannel/localisation/${salesChannelUuid}`,
    {},
  );
};

export const setLocalisation = (body: any) => {
  return post<any>(`/portal/setting/salesChannel/localisation`, body, {});
};
